import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { OBJECT_NAME_RULE, EMAIL_RULE, MOBILE_NUMBER_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import IdNameModel from "../../../models/common/IdNameModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import CompanyInterviewerRequestModel from "../../../models/company/company-interviewers/request/CompanyInterviewerRequestModel";
import toasterUtils from "../../../utils/toaster-utils";
import { TextField, Select, MenuItem, Button, FormControl, InputLabel, FormHelperText, Autocomplete } from "@mui/material";

interface CompanyInterviewerProps {
    objInterviewer: CompanyInterviewerRequestModel;
    primarySKills: IdNameModel[];
    cities: IdNameModel[];
    experiences: IdNameModel[];
    onCloseInterviewer: () => void;
    onInterviewerSave: (objInterviewer: CompanyInterviewerRequestModel) => void;
}

const CompanyInterviewerCreateComponent = (props: CompanyInterviewerProps) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<CompanyInterviewerRequestModel>({
        mode: "onChange",
        defaultValues: props.objInterviewer
    });

    const onSubmit = (formData: CompanyInterviewerRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (formData.primarySkillId === null || formData.cityId === null || formData.experienceId === null || !isValid
            || formData.primarySkillId === 0 || formData.cityId === 0 || formData.experienceId === 0) {
            toasterUtils.showError("Please Fill all mandatory fields");
            return;
        }
        formData.userName = formData.emailId;
        props.onInterviewerSave(formData);
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.name}>
                        <TextField label="Name" size="small" {...register("name", OBJECT_NAME_RULE)} error={!!errors.name}
                            helperText={errors.name?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.emailId}>
                        <TextField type="email" label="Email" size="small" {...register("emailId", EMAIL_RULE)} error={!!errors.emailId}
                            helperText={errors.emailId?.message} autoComplete="off" disabled={props.objInterviewer.interviewerId !== GuidEnum.Empty} required />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                        <TextField type="text" label="Mobile No" size="small" {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber}
                            helperText={errors.mobileNumber?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <Controller name="primarySkillId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.primarySKills.find(x => x.id === field.value) || null}
                                onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.primarySKills} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Primary Skill" size="small" required margin="normal" fullWidth error={!!errors.primarySkillId} helperText={errors.primarySkillId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Controller name="cityId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.cities.find(x => x.id === field.value) || null}
                                onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.cities} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="City" size="small" required margin="normal" fullWidth error={!!errors.cityId} helperText={errors.cityId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <Controller name="experienceId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.experiences.find(x => x.id === field.value) || null}
                                onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.experiences} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Experience" size="small" required margin="normal" fullWidth error={!!errors.experienceId} helperText={errors.experienceId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end mt-2">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseInterviewer}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default CompanyInterviewerCreateComponent;